import React, { FC } from 'react';
import { useIntlBds } from '../../translations/BdsIntlProvider';
import { Paper, PaperProps } from '../Paper/Paper';
import { styled } from '../../styles';
import { Typography } from '../Typography/Typography';
import { Switch } from '../Form/Switch';
import { Divider } from '../Divider/Divider';
import { Box } from '../Box/Box';
import { ListItemText } from '../List/ListItemText';

interface Props extends PaperProps {
  isEditModeEnabled: boolean;
  hasEditOption: boolean;
  setEditMode: () => void;
  hasAddSearchOption: boolean;
}

export const PaperComponent: FC<React.PropsWithChildren<Props>> = ({
  children,
  dataTest,
  setEditMode,
  isEditModeEnabled,
  hasEditOption,
  hasAddSearchOption,
  ...props
}) => {
  const { intl } = useIntlBds();
  return (
    <Paper {...props} onMouseDown={(e) => e.preventDefault()}>
      {hasEditOption && (
        <>
          <ListItemText
            className="MuiAutocomplete-option"
            onClick={setEditMode}
            dataTest={`${dataTest}-list-item-manage-tags`}
            primary={
              <StyledManageTags>
                <Typography component="div">{intl.Tags.manageTagsTitle}</Typography>
                <Switch checked={isEditModeEnabled} size="small" onChange={() => {}} />
              </StyledManageTags>
            }
          />
          <Divider />
        </>
      )}
      <Box>{children}</Box>
    </Paper>
  );
};

const StyledManageTags = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 16px;
  min-height: 41px;
  cursor: pointer;
`;
